import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Button, TextField, InputAdornment } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchJobs } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function JobListPage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      setRows(await fetchJobs(businessDomainId));
    } catch (e) {
      notify.apiError(e);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessDomainId]);

  useEffect(() => { loadData(); }, [loadData]);

  const handleRowClick = (params) => {
    navigate(`/design/${businessDomainId}/jobs/${params.row.jobId}`);
  };

  const filteredRows = searchText
    ? rows.filter((r) => r.jobName?.toLowerCase().includes(searchText.toLowerCase()))
    : rows;

  const columns = [
    { field: "jobName", headerName: t("job.name"), flex: 1, minWidth: 200 },
    { field: "jobDescription", headerName: t("job.description"), flex: 1, minWidth: 200 },
  ];

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("job.list.title")}</Typography>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <TextField size="small" placeholder={t("common.search")} value={searchText} onChange={(e) => setSearchText(e.target.value)} InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate(`/design/${businessDomainId}/jobs/create`)}>{t("common.add")}</Button>
        </Box>
      </Box>
      <DataGrid
        rows={filteredRows}
        columns={columns}
        getRowId={(r) => r.jobId}
        loading={loading}
        autoHeight
        hideFooter
        onRowClick={handleRowClick}
        sx={{ "& .MuiDataGrid-row": { cursor: "pointer" } }}
        disableRowSelectionOnClick
      />
    </Box>
  );
}
